export const AUTH_COOKIE_NAME = 'auth';
export const TEMP_AUTH_COOKIE_NAME = 'tempAuth';
export const TEMP_WORKSPACE_COOKIE_NAME = 'tempWorkspace';

export const APP_TOKEN_PREFIX = 'pb_app_';
export const API_TOKEN_PREFIX = 'pb_api_';
export const MKT_TOKEN_PREFIX = 'pb_mkt_';

type CookieMap = Record<string, any>;

type AuthHeaderOptions = {
	admin?: boolean;
	headers?: Record<string, any>;
	titleCase?: boolean;
};

const read = (cookies: CookieMap = {}, key: string) => cookies?.[key];

export const extractRawToken = (model: any = {}) => {
	return model?.rawToken || model?.token?.rawToken || '';
};

export const isAppToken = (token = '') => token.startsWith(APP_TOKEN_PREFIX);
export const isApiToken = (token = '') => token.startsWith(API_TOKEN_PREFIX);
export const isMktToken = (token = '') => token.startsWith(MKT_TOKEN_PREFIX);

export const readAuthCookies = (cookies: CookieMap = {}, admin = false) => {
	const authorization = read(cookies, AUTH_COOKIE_NAME);
	const tempAuth = read(cookies, TEMP_AUTH_COOKIE_NAME);
	const workspace = read(cookies, 'workspace');
	const tempWorkspace = read(cookies, TEMP_WORKSPACE_COOKIE_NAME);

	if (!admin && tempAuth) {
		return {
			authorization: tempAuth,
			workspace: tempWorkspace || workspace,
		};
	}

	return { authorization, workspace };
};

export const hasAuthCookie = (cookies: CookieMap = {}, options: { admin?: boolean } = {}) => {
	return Boolean(readAuthCookies(cookies, options.admin).authorization);
};

export const formatAuthHeaders = (cookies: CookieMap = {}, options: AuthHeaderOptions = {}) => {
	const { admin = false, headers = {}, titleCase = true } = options;
	const { authorization, workspace } = readAuthCookies(cookies, admin);
	if (!authorization) return { ...headers };

	return {
		[titleCase ? 'Authorization' : 'authorization']: authorization,
		...(workspace ? { [titleCase ? 'Workspace' : 'workspace']: workspace } : {}),
		...headers,
	};
};
